import React from 'react';

/**
 * Garde-fou autour du diaporama publicitaire.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * POURQUOI : la publicité est un CONFORT, la file d'attente est le MÉTIER. Sans cette
 * barrière, une slide mal formée — une URL que le navigateur refuse, un champ absent —
 * fait tomber le rendu React et l'écran de la salle d'attente devient BLANC. Plus de
 * tickets, plus d'appels, plus rien : des gens attendent devant un écran vide, et
 * personne sur place ne sait redémarrer quoi que ce soit.
 *
 * Une erreur ici doit donc coûter la publicité, jamais l'affichage. On rend `fallback`
 * (le résumé de la journée) et on continue.
 *
 * Volontairement SILENCIEUX à l'écran : afficher une trace technique devant le public
 * n'aide personne. La console du navigateur garde le détail pour le diagnostic.
 */
export class AdErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { enPanne: false };
  }

  static getDerivedStateFromError() {
    return { enPanne: true };
  }

  componentDidCatch(error, info) {
    console.error('[publicité] slide fautive — la publicité est désactivée, l\'affichage continue', error, info);
  }

  componentDidUpdate(prevProps) {
    // Une configuration corrigée depuis la console doit pouvoir relancer la publicité
    // sans qu'on ait à redémarrer l'écran : c'est souvent hors de portée de l'exploitant.
    if (this.state.enPanne && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ enPanne: false });
    }
  }

  render() {
    if (this.state.enPanne) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default AdErrorBoundary;
